import React from 'react';
import { Button } from './ui/button';
import { processSteps } from '../mockData';

const Process = () => {
  return (
    <section id="process" className="py-24 bg-white relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-10 w-72 h-72 bg-cyan-200 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-100 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="text-cyan-800 text-sm font-semibold tracking-wider uppercase mb-4">
            OUR PROCESS
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Your Journey to a Dream Theatre
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Simple, transparent, and professional—from consultation to lifetime support
          </p>
        </div>

        {/* Horizontal Timeline */}
        <div className="max-w-7xl mx-auto relative">
          {/* Connecting Line */}
          <div className="absolute top-8 left-0 right-0 h-0.5 bg-gradient-to-r from-cyan-200 via-cyan-600 to-cyan-200 hidden md:block"></div>

          {/* Steps in horizontal layout */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 relative">
            {processSteps.map((step) => (
              <div 
                key={step.id} 
                className="flex flex-col items-center text-center"
              >
                {/* Number Circle */}
                <div className="relative mb-6 group">
                  <div className="relative w-16 h-16 bg-cyan-800 rounded-full flex items-center justify-center text-2xl font-bold text-white shadow-lg shadow-cyan-800/30 group-hover:scale-110 transition-all duration-300 z-10">
                    <span className="relative z-10">{step.id}</span>
                    {/* Pulse effect */}
                    <div className="absolute inset-0 rounded-full bg-cyan-500 animate-ping opacity-20"></div>
                  </div>
                </div>

                {/* Content Card */}
                <div className="bg-white rounded-2xl p-6 border-2 border-cyan-100 hover:border-cyan-300 transition-all duration-300 hover:shadow-xl h-full">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 hover:text-cyan-800 transition-colors duration-300">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed hover:text-gray-700 transition-colors duration-300">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-3xl mx-auto mt-16 text-center p-8 rounded-2xl bg-gradient-to-br from-cyan-50 to-white border-2 border-cyan-200 hover:shadow-xl transition-all duration-300">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Get Started?</h3>
          <p className="text-gray-600 mb-6">
            Schedule a free consultation today and let's discuss how we can transform your home.
          </p>
          <Button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-cyan-800 hover:bg-cyan-900 text-white font-semibold px-8 py-6 text-lg rounded-full hover:scale-105 transition-all duration-300 shadow-lg shadow-cyan-800/30"
          >
            Schedule Free Consultation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Process;
